import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function SmsOptIn() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    smsConsent: false,
    emailConsent: false
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <>
      <Helmet>
        <title>SMS Opt-In Example - TEJ Solutions Hub</title>
        <meta name="description" content="Example SMS opt-in form showing how to collect consent for SMS communications in compliance with TCPA regulations." />
      </Helmet>

      <div style={{ paddingTop: '100px', background: '#f9fafb', minHeight: '100vh' }}>
        <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '4rem 2rem', color: 'white', textAlign: 'center' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800' }}>SMS Opt-In Example</h1>
          <p style={{ fontSize: '1.1rem', opacity: '0.95' }}>Sample Consent Form for SMS Communications</p>
        </div>

        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '4rem 2rem' }}>
          
          {/* Important Notice */}
          <div style={{ background: '#dbeafe', padding: '2rem', borderRadius: '12px', marginBottom: '3rem', border: '2px solid #3b82f6' }}>
            <p style={{ fontSize: '1.1rem', color: '#1e40af', fontWeight: '600', marginBottom: '1rem' }}>
              📋 Example SMS Opt-In Form
            </p>
            <p style={{ fontSize: '1rem', color: '#1e40af', lineHeight: '1.8', marginBottom: '1rem' }}>
              This page demonstrates a compliant SMS opt-in form. This example shows how businesses should collect SMS consent from their customers.
            </p>
            <p style={{ fontSize: '0.95rem', color: '#1e40af', lineHeight: '1.6' }}>
              <strong>Note:</strong> This is a demonstration form showing best practices for SMS consent collection in compliance with TCPA and carrier requirements.
            </p>
          </div>

          {/* Example Form */}
          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1rem' }}>
              Example: Client SMS Opt-In Form
            </h2>
            <p style={{ fontSize: '0.95rem', color: '#6b7280', marginBottom: '2rem' }}>
              This is how businesses using our platform collect consent from their customers:
            </p>

            {submitted ? (
              <div style={{ background: '#d1fae5', padding: '2rem', borderRadius: '12px', border: '2px solid #10b981', textAlign: 'center' }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✓</div>
                <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#065f46', marginBottom: '1rem' }}>
                  Example Submission Complete
                </h3>
                <p style={{ fontSize: '1rem', color: '#065f46', lineHeight: '1.8' }}>
                  This demonstrates how consent is recorded. In a real implementation, this data would be stored with timestamp and consent documentation for compliance.
                </p>
                <button
                  onClick={() => setSubmitted(false)}
                  style={{
                    marginTop: '1.5rem',
                    padding: '0.75rem 2rem',
                    background: '#7c3aed',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  Reset Form
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="John Doe"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '2px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '1rem'
                    }}
                  />
                </div>

                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                    Mobile Phone Number *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="(555) 123-4567"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '2px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '1rem'
                    }}
                  />
                </div>

                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="john@example.com"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '2px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '1rem'
                    }}
                  />
                </div>

                {/* SMS Consent Checkbox */}
                <div style={{ background: '#fef3c7', padding: '1.5rem', borderRadius: '8px', border: '2px solid #fbbf24', marginBottom: '1.5rem' }}>
                  <label style={{ display: 'flex', alignItems: 'start', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      name="smsConsent"
                      checked={formData.smsConsent}
                      onChange={handleChange}
                      required
                      style={{
                        width: '20px',
                        height: '20px',
                        marginRight: '1rem',
                        marginTop: '0.25rem',
                        cursor: 'pointer'
                      }}
                    />
                    <span style={{ fontSize: '0.95rem', color: '#78350f', lineHeight: '1.6' }}>
                      <strong>SMS Consent Required *</strong><br/>
                      By checking this box and providing my mobile phone number, I agree to receive SMS/MMS marketing messages from [Business Name] at the number provided above. I understand that:
                      <ul style={{ marginTop: '0.5rem', marginBottom: '0.5rem', paddingLeft: '1.5rem' }}>
                        <li>Message frequency varies</li>
                        <li>Message and data rates may apply</li>
                        <li>Consent is not a condition of purchase</li>
                        <li>I can reply STOP to unsubscribe at any time</li>
                        <li>I can reply HELP for help</li>
                      </ul>
                      View <Link to="/privacy-policy" style={{ color: '#7c3aed', fontWeight: '600' }}>Privacy Policy</Link> and <Link to="/terms-and-conditions" style={{ color: '#7c3aed', fontWeight: '600' }}>Terms</Link>.
                    </span>
                  </label>
                </div>

                {/* Email Consent Checkbox */}
                <div style={{ background: '#f3f4f6', padding: '1.5rem', borderRadius: '8px', border: '2px solid #d1d5db', marginBottom: '2rem' }}>
                  <label style={{ display: 'flex', alignItems: 'start', cursor: 'pointer' }}>
                    <input
                      type="checkbox"
                      name="emailConsent"
                      checked={formData.emailConsent}
                      onChange={handleChange}
                      style={{
                        width: '20px',
                        height: '20px',
                        marginRight: '1rem',
                        marginTop: '0.25rem',
                        cursor: 'pointer'
                      }}
                    />
                    <span style={{ fontSize: '0.95rem', color: '#374151', lineHeight: '1.6' }}>
                      <strong>Email Marketing (Optional)</strong><br/>
                      I also agree to receive promotional emails from [Business Name]. I can unsubscribe at any time by clicking the unsubscribe link in any email.
                    </span>
                  </label>
                </div>

                <button
                  type="submit"
                  disabled={!formData.smsConsent}
                  style={{
                    width: '100%',
                    padding: '1rem',
                    background: formData.smsConsent ? 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)' : '#d1d5db',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    cursor: formData.smsConsent ? 'pointer' : 'not-allowed',
                    transition: 'all 0.3s ease'
                  }}
                >
                  {formData.smsConsent ? 'Submit Opt-In' : 'Please Accept SMS Consent'}
                </button>

                <p style={{ fontSize: '0.85rem', color: '#6b7280', textAlign: 'center', marginTop: '1rem' }}>
                  * Required fields
                </p>
              </form>
            )}
          </div>

          {/* Compliance Information */}
          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginTop: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              How This Form Ensures Compliance
            </h2>
            
            <div style={{ display: 'grid', gap: '1rem' }}>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>✓ Express Written Consent</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  Checkbox requires active opt-in (not pre-checked)
                </p>
              </div>

              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>✓ Clear Disclosures</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  Message frequency, rates, and opt-out instructions clearly stated
                </p>
              </div>

              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>✓ No Purchase Condition</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  States "Consent is not a condition of purchase"
                </p>
              </div>

              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>✓ Opt-Out Instructions</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  STOP keyword and help instructions provided
                </p>
              </div>

              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>✓ Separate Consent</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  SMS and email consent collected separately
                </p>
              </div>

              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>✓ Timestamp & Documentation</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  In production, consent is logged with timestamp and IP for compliance records
                </p>
              </div>
            </div>
          </div>

          {/* Links */}
          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <Link to="/sms-opt-in-disclosure" style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              marginRight: '1rem'
            }}>
              SMS Opt-In Disclosure
            </Link>
            <Link to="/sms-compliance-consent" style={{
              display: 'inline-block',
              background: 'white',
              color: '#7c3aed',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              border: '2px solid #7c3aed'
            }}>
              Compliance Policy
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
